import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();
  
  private loading: boolean = false;
  loader = signal(false);
  private _label: string = '';

  constructor() {}

  start() {
    setTimeout(() => {
      this._loading.next(true);
      this.loading = true;
      this.loader.set(true);
    }, 0);
  }

  stop() {
    setTimeout(() => {
      this._loading.next(false);
      this.loading = false;
      this.loader.set(false);
    }, 0);
  }

  setLoading(loading: boolean) {
    setTimeout(() => {
      this.loading = loading;
      this._loading.next(loading);
      this.loader.set(loading);
    }, 0);
  }

  getLoading(): boolean {
    return this.loading;
  }

  public get label(): string {
    return this._label;
  }
  public set label(value: string) {
    this._label = value;
  }
}
